import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import EventListPage from './pages/EventListPage';
import EventPage from './pages/EventPage';
import SuccessPage from './pages/SuccessPage';
import BookingDetailPage from './pages/BookingDetailPage';
import MyBookingsPage from './pages/MyBookingsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/events" element={<EventListPage />} />
        <Route path="/event/:eventId" element={<EventPage />} />
        <Route path="/success/:bookingId" element={<SuccessPage />} />
        <Route path="/booking/:bookingId" element={<BookingDetailPage />} />
        <Route path="/my-bookings" element={<MyBookingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
